import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { appStore } from "src/appStore";
import {
  ZObjectRefSelector,
  ZObjectRefTable,
} from "src/common/attrEdit/components";
import { loadAttrTypeMap } from "src/common/attributes";
import { getEntityCachedRequest } from "src/common/entity/getEntityCachedRequest";
import { onError } from "src/common/onError";
import { filterAttrLabelData } from "src/common/attributes/makeAttrLabel/utils/filterAttrLabelData";
import { getAllLabelDataAttributes } from "src/common/attributes/makeAttrLabel/utils/getAllLabelDataAttributes";
import { getLeaves } from "src/common/attributes/makeAttrLabel/utils/getLeaves";
import { formatAllLabels } from "src/common/attributes/makeAttrLabel/utils/formatAllLabels";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";
import { AttrTypeName } from "src/types/AttrType";
import { ZUid } from "src/types/zUid";
import styles from "./ObjectRefSelector.module.less";

interface PropsObjectRefSelectorLabel {
  component: ZObjectRefSelector | ZObjectRefTable | null;
  entityId: ZUid;
  entityLabel?: React.ReactNode;
}

export const ObjectRefSelectorLabel: React.FC<PropsObjectRefSelectorLabel> = ({
  component,
  entityId,
  entityLabel,
}) => {
  const [label, setLabel] = useState<React.ReactNode>();
  const [loading, setLoading] = useState(false);
  const init = async () => {
    try {
      if (entityLabel) {
        return;
      }
      setLoading(true);
      const entity = await getEntityCachedRequest(entityId);
      const typesMap = await loadAttrTypeMap();

      const allAttributes = getAllLabelDataAttributes(
        entity.labelData?.attributes,
      );
      const formatted = formatAllLabels(
        entity.labelData?.labels || [],
        allAttributes,
        typesMap,
      );

      const filtered = filterAttrLabelData(formatted, allAttributes, typesMap, [
        AttrTypeName.image,
        AttrTypeName.file,
      ]);

      const newLabelsMap = new Map(filtered.map((e) => [e.attrId, e]));
      const atts4Show = component?.labelAtts || [];
      const finalLabels = atts4Show
        .map((lId) => {
          const attrTreeData = newLabelsMap.get(lId);
          if (!attrTreeData) return null;
          const leaves = getLeaves(attrTreeData);
          return leaves
            .map(({ labels }) => labels)
            .flat()
            .join(",");
        })
        .filter((e) => !!e)
        .join(",");

      setLabel(finalLabels);
    } catch (error) {
      onError(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    init();
  }, [entityId, component]);

  if (loading) return <Spin>...</Spin>;

  return appStore.isNotAuth ? (
    <span>{label}</span>
  ) : (
    <Link
      to={makeUrl(PageUrl.entityCard, { id: entityId })}
      className={styles.entityLink}
      target="_blank"
      onClick={(e) => e.stopPropagation()}
    >
      {entityLabel || label || entityId}
    </Link>
  );
};
